"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ethereum = void 0;
exports.ethereum = {
    "addresses": {
        "ProxyAdmin": "0xf70B2473e7808eDAeA4A5Cea95996A9B1843D96C",
        "Multicall2": "0xcA11bde05977b3631167028862bE2a173976CA11",
        "Sumer": "0x553d713e0fB958932b6C40ABAf0b5A1fFae73Da2",
        "CompoundLens": "0xDf66fB107e8927424603Aafd556e6b1B39eFce04",
        "FeedPriceOracle": "0x0af6E02F3cC1bfeba408383DcD382872Fd5Da592",
        "CompLogic": "0xAc6bAF36B28d19EA10959102158Beb3d933C1fbf",
        "RedemptionManager": "0xC6C338eC3b4aa5e5237b9B8427741a582f96568D",
        "Timelock": "0x3CfC6b4E9a8f030F6894d35618A8315af3E30DB9",
        "Comptroller": "0x60A4570bE892fb41280eDFE9DB75e1a62C70456F",
        "sdrETH": "0x42778d0962884510b85d4D1B30DFe9e9Dd270446",
        "ETH": "0x0000000000000000000000000000000000000000",
        "CErc20": "0xDeD795A8Cf0784265a3A90613Ad675879a0660b6",
        "suErc20": "0x7b1D6dda0cB59c0c87a3d07e97a66e23aE3aF969",
        "WstETHAdapter": "0x29452DDcA942026468A118793e1e0a802C0bBC59",
        "JumpRate#StableBC": "0xA6b8f446671804451906D48E26Ad7AEBCc607bDA",
        "JumpRate#wstETH": "0xe131f7A95b62CbEeceB7b03F08790930e6894a7E",
        "JumpRate#BTCBC_AltStables": "0x431a4bC9AbF86697b6717718495e3924F2c194a9",
        "JumpRate#ETH": "0xB5d58D32305CE7b955B5926bf6b567cd9fB42520",
        "JumpRate#Others": "0xE649Fd017356D314e79649fBE5E20A9EC827D286",
        "ZeroRate": "0x901f52D04324879a37587406BEa16bcD1C11f061",
        "sdrUSDC": "0x3d592e26050e132Ee3D1504aca74f0F4Ed75e5cC",
        "USDC": "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
        "sdrUSDT": "0xe3502f1c2450Ed1Bb87B87a84AF6742F60f41368",
        "USDT": "0xdAC17F958D2ee523a2206206994597C13D831ec7",
        "sdrDAI": "0x5096E5cf4f151052ACD615b2635E7FdB6Db0763C",
        "DAI": "0x6B175474E89094C44Da98b954EedeAC495271d0F",
        "sdrsDAI": "0xE27496Ec5d6E19521d636e78c127fF2Cf59ee914",
        "sDAI": "0x83F20F44975D03b1b09e64809B757c47f942BEeA",
        "sdrUSDe": "0xF5d682D42e16550Cc5D8f48193243103D2CeAF0a",
        "USDe": "0x4c9EDD5852cd905f086C759E8383e09bff1E68B3",
        "sdrsUSDe": "0x549D0CdC753601fbE29f9DE186868429a8558E07",
        "sUSDe": "0x9D39A5DE30e57443BfF2A8307A4256c8797A3497",
        "sdrPT-sUSDE-26SEP2024": "0xa46D0328Dfa5822d3E9B4423E2A0A73467c2d2d5",
        "PT-sUSDE-26SEP2024": "0x6c9f097e044506712B58EAC670c9a5fd4BCceF13",
        "sdrwstETH": "0x15B5220024c3242F7D61177D6ff715cfac4909eD",
        "wstETH": "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
        "sdrRETH": "0x1FF86e97b273dE2b1D42F0FDD5Ea7350A66c4857",
        "RETH": "0xae78736Cd615f374D3085123A210448E74Fc6393",
        "sdrpufETH": "0x23811C17BAc40500deCD5FB92d4FEb972aE1E607",
        "pufETH": "0xD9A442856C234a39a81a089C06451EBAa4306a72",
        "sdrrsETH": "0x61561B2E01C69C2906735866C94Cc4a33bB71c85",
        "rsETH": "0xA1290d69c65A6Fe4DF752f95823fae25cB99e5A7",
        "sdrweETH": "0xBc6590A7b15513e4D649b158393175a839F27ED8",
        "weETH": "0xCd5fE23C85820F7B72D0926FC9b05b43E359b7ee",
        "sdrPT-weETH-26SEP2024": "0xE550a6f792a8B6C07555378EA74063021885A33e",
        "PT-weETH-26SEP2024": "0x1c085195437738d73d75DC64bC5A3E098b7f93b1",
        "sdrPT-pufETH-26SEP2024": "0xf7BB299dc8e627eaEc4282FFc236E085aef8FAF3",
        "PT-pufETH-26SEP2024": "0xd4e75971eAF78a8d93D96df530f1FFf5f9F53288",
        "sdrPT-rsETH-26DEC2024": "0x09Ec28782a71627b61Dce160Fc0FBbC1edBd2A6D",
        "PT-rsETH-26DEC2024": "0xb07b9fdd62dc478e521e8bde3630a777725b0eb4",
        "sdrPT-weETH-26DEC2024": "0x3d9b5399059d36644B8b67860439Af221C67B273",
        "PT-weETH-26DEC2024": "0x6ee2b5E19ECBa773a352E5B21415Dc419A700d1d",
        "sdrPT-pufETH-26DEC2024": "0x29688DdC25ecd3307Aa4A83CA3AbB18F6AD70738",
        "PT-pufETH-26DEC2024": "0xF6fd7Ceb095BfD54130359Cc9366a1493944213A",
        "sdrxSolvBTC": "0x5573Fc3650d2a38D1C83faDf682bC379CFAcCFA1",
        "xSolvBTC": "0xd9D920AA40f578ab794426F5C90F6C731D159DEf",
        "sdrSolvBTC": "0xA9Ea90899fA648b4Ce49f6aE28174AEAda660118",
        "SolvBTC": "0x7A56E1C57C7475CCf742a1832B028F0456652F97",
        "sdrtBTC": "0x1bC39d2E227481087f21de67Bae32BC5bc36C70b",
        "tBTC": "0x18084fbA666a33d37592fA2633fD49a74DD93a88",
        "sdrFBTC": "0x91942b802439f2169C36441eF3b250AF6bAc15bD",
        "FBTC": "0xC96dE26018A54D51c097160568752c4E3BD6C364",
        "sdreBTC": "0x83db38Aa8d165340012bb734bdd408C46a39d6dD",
        "eBTC": "0x657e8C867D8B37dCC18fA4Caead9C45EB088C642",
        "sdrWBTC": "0xdCA98947c3c9cf0B3CF448b6A03f991598Fb9460",
        "WBTC": "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
        "sdrsuUSD": "0x2509bd3B69440D39238b464d09f9F04A61fd62C6",
        "suUSD": "0x8bf591eae535f93a242d5a954d3cde648b48a5a8",
        "sdrsuETH": "0x4342e9bf67F89dea0Cf3c906F5113Dd8b588aC6F",
        "suETH": "0x1c22531aa9747d76fff8f0a43b37954ca67d28e0",
        "sdrsuBTC": "0x77CcA710E21A94B94a26A98eA23027D64e36B9d4",
        "suBTC": "0xe85411c030fb32a9d8b14bbbc6cb19417391f711"
    },
    "tokenPairs": [
        {
            "ctokenSym": "sdrUSDC",
            "ctokenAddr": "0x3d592e26050e132Ee3D1504aca74f0F4Ed75e5cC",
            "underlySym": "USDC",
            "ctokenDecimal": 6,
            "underlyDecimal": 6,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
            "assetGroupId": 1
        },
        {
            "ctokenSym": "sdrUSDT",
            "ctokenAddr": "0xe3502f1c2450Ed1Bb87B87a84AF6742F60f41368",
            "underlySym": "USDT",
            "ctokenDecimal": 6,
            "underlyDecimal": 6,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0xdAC17F958D2ee523a2206206994597C13D831ec7",
            "assetGroupId": 1
        },
        {
            "ctokenSym": "sdrDAI",
            "ctokenAddr": "0x5096E5cf4f151052ACD615b2635E7FdB6Db0763C",
            "underlySym": "DAI",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x6B175474E89094C44Da98b954EedeAC495271d0F",
            "assetGroupId": 1
        },
        {
            "ctokenSym": "sdrUSDe",
            "ctokenAddr": "0xF5d682D42e16550Cc5D8f48193243103D2CeAF0a",
            "underlySym": "USDe",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x4c9EDD5852cd905f086C759E8383e09bff1E68B3",
            "assetGroupId": 1
        },
        {
            "ctokenSym": "sdrsUSDe",
            "ctokenAddr": "0x549D0CdC753601fbE29f9DE186868429a8558E07",
            "underlySym": "sUSDe",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x9D39A5DE30e57443BfF2A8307A4256c8797A3497",
            "assetGroupId": 1
        },
        {
            "ctokenSym": "sdrPT-sUSDE-26SEP2024",
            "ctokenAddr": "0xa46D0328Dfa5822d3E9B4423E2A0A73467c2d2d5",
            "underlySym": "PT-sUSDE-26SEP2024",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x6c9f097e044506712B58EAC670c9a5fd4BCceF13",
            "assetGroupId": 1
        },
        {
            "ctokenSym": "sdrwstETH",
            "ctokenAddr": "0x15B5220024c3242F7D61177D6ff715cfac4909eD",
            "underlySym": "wstETH",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
            "assetGroupId": 2
        },
        {
            "ctokenSym": "sdrRETH",
            "ctokenAddr": "0x1FF86e97b273dE2b1D42F0FDD5Ea7350A66c4857",
            "underlySym": "RETH",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0xae78736Cd615f374D3085123A210448E74Fc6393",
            "assetGroupId": 2
        },
        {
            "ctokenSym": "sdrpufETH",
            "ctokenAddr": "0x23811C17BAc40500deCD5FB92d4FEb972aE1E607",
            "underlySym": "pufETH",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0xD9A442856C234a39a81a089C06451EBAa4306a72",
            "assetGroupId": 2
        },
        {
            "ctokenSym": "sdrrsETH",
            "ctokenAddr": "0x61561B2E01C69C2906735866C94Cc4a33bB71c85",
            "underlySym": "rsETH",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0xA1290d69c65A6Fe4DF752f95823fae25cB99e5A7",
            "assetGroupId": 2
        },
        {
            "ctokenSym": "sdrweETH",
            "ctokenAddr": "0xBc6590A7b15513e4D649b158393175a839F27ED8",
            "underlySym": "weETH",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0xCd5fE23C85820F7B72D0926FC9b05b43E359b7ee",
            "assetGroupId": 2
        },
        {
            "ctokenSym": "sdrPT-weETH-26SEP2024",
            "ctokenAddr": "0xE550a6f792a8B6C07555378EA74063021885A33e",
            "underlySym": "PT-weETH-26SEP2024",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x1c085195437738d73d75DC64bC5A3E098b7f93b1",
            "assetGroupId": 2
        },
        {
            "ctokenSym": "sdrPT-pufETH-26SEP2024",
            "ctokenAddr": "0xf7BB299dc8e627eaEc4282FFc236E085aef8FAF3",
            "underlySym": "PT-pufETH-26SEP2024",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0xd4e75971eAF78a8d93D96df530f1FFf5f9F53288",
            "assetGroupId": 2
        },
        {
            "ctokenSym": "sdrPT-rsETH-26DEC2024",
            "ctokenAddr": "0x09Ec28782a71627b61Dce160Fc0FBbC1edBd2A6D",
            "underlySym": "PT-rsETH-26DEC2024",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0xb07b9fdd62dc478e521e8bde3630a777725b0eb4",
            "assetGroupId": 2
        },
        {
            "ctokenSym": "sdrPT-weETH-26DEC2024",
            "ctokenAddr": "0x3d9b5399059d36644B8b67860439Af221C67B273",
            "underlySym": "PT-weETH-26DEC2024",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x6ee2b5E19ECBa773a352E5B21415Dc419A700d1d",
            "assetGroupId": 2
        },
        {
            "ctokenSym": "sdrPT-pufETH-26DEC2024",
            "ctokenAddr": "0x29688DdC25ecd3307Aa4A83CA3AbB18F6AD70738",
            "underlySym": "PT-pufETH-26DEC2024",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0xF6fd7Ceb095BfD54130359Cc9366a1493944213A",
            "assetGroupId": 2
        },
        {
            "ctokenSym": "sdrxSolvBTC",
            "ctokenAddr": "0x5573Fc3650d2a38D1C83faDf682bC379CFAcCFA1",
            "underlySym": "xSolvBTC",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0xd9D920AA40f578ab794426F5C90F6C731D159DEf",
            "assetGroupId": 4
        },
        {
            "ctokenSym": "sdrSolvBTC",
            "ctokenAddr": "0xA9Ea90899fA648b4Ce49f6aE28174AEAda660118",
            "underlySym": "SolvBTC",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x7A56E1C57C7475CCf742a1832B028F0456652F97",
            "assetGroupId": 4
        },
        {
            "ctokenSym": "sdrtBTC",
            "ctokenAddr": "0x1bC39d2E227481087f21de67Bae32BC5bc36C70b",
            "underlySym": "tBTC",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x18084fbA666a33d37592fA2633fD49a74DD93a88",
            "assetGroupId": 3
        },
        {
            "ctokenSym": "sdrFBTC",
            "ctokenAddr": "0x91942b802439f2169C36441eF3b250AF6bAc15bD",
            "underlySym": "FBTC",
            "ctokenDecimal": 8,
            "underlyDecimal": 8,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0xC96dE26018A54D51c097160568752c4E3BD6C364",
            "assetGroupId": 4
        },
        {
            "ctokenSym": "sdreBTC",
            "ctokenAddr": "0x83db38Aa8d165340012bb734bdd408C46a39d6dD",
            "underlySym": "eBTC",
            "ctokenDecimal": 8,
            "underlyDecimal": 8,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x657e8C867D8B37dCC18fA4Caead9C45EB088C642",
            "assetGroupId": 4
        },
        {
            "ctokenSym": "sdrWBTC",
            "ctokenAddr": "0xdCA98947c3c9cf0B3CF448b6A03f991598Fb9460",
            "underlySym": "WBTC",
            "ctokenDecimal": 8,
            "underlyDecimal": 8,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
            "assetGroupId": 3
        },
        {
            "ctokenSym": "sdrsuUSD",
            "ctokenAddr": "0x2509bd3B69440D39238b464d09f9F04A61fd62C6",
            "underlySym": "suUSD",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x8bf591eae535f93a242d5a954d3cde648b48a5a8",
            "assetGroupId": 1
        },
        {
            "ctokenSym": "sdrsuETH",
            "ctokenAddr": "0x4342e9bf67F89dea0Cf3c906F5113Dd8b588aC6F",
            "underlySym": "suETH",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x1c22531aa9747d76fff8f0a43b37954ca67d28e0",
            "assetGroupId": 2
        },
        {
            "ctokenSym": "sdrsuBTC",
            "ctokenAddr": "0x77CcA710E21A94B94a26A98eA23027D64e36B9d4",
            "underlySym": "suBTC",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0xe85411c030fb32a9d8b14bbbc6cb19417391f711",
            "assetGroupId": 3
        },
        {
            "ctokenSym": "sdrETH",
            "ctokenAddr": "0x42778d0962884510b85d4D1B30DFe9e9Dd270446",
            "underlySym": "ETH",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": true,
            "permitEnabled": false,
            "underlyAddr": "0x0000000000000000000000000000000000000000"
        }
    ],
    "rateModels": [
        {
            "name": "JumpRate#ETH",
            "contract": "JumpRateModelV2",
            "address": "0xB5d58D32305CE7b955B5926bf6b567cd9fB42520",
            "tokens": [
                "ETH",
                "ETH"
            ],
            "baseRatePerYear": "0",
            "multiplierPerYear": "0.036",
            "jumpMultiplierPerYear": "3.2",
            "kink": "0.75"
        },
        {
            "name": "JumpRate#StableBC",
            "contract": "JumpRateModelV2",
            "address": "0xA6b8f446671804451906D48E26Ad7AEBCc607bDA",
            "tokens": [
                "USDC",
                "USDT",
                "DAI",
                "WBTC"
            ],
            "baseRatePerYear": "0",
            "multiplierPerYear": "0.09333",
            "jumpMultiplierPerYear": "3.2",
            "kink": "0.8"
        },
        {
            "name": "JumpRate#BTCBC_AltStables",
            "contract": "JumpRateModelV2",
            "address": "0x431a4bC9AbF86697b6717718495e3924F2c194a9",
            "tokens": [
                "sDAI",
                "USDe",
                "sUSDe",
                "PT-sUSDE-26SEP2024",
                "tBTC",
                "FBTC"
            ],
            "baseRatePerYear": "0",
            "multiplierPerYear": "0.0889",
            "jumpMultiplierPerYear": "5.52727",
            "kink": "0.45"
        },
        {
            "name": "JumpRate#wstETH",
            "contract": "JumpRateModelV2",
            "address": "0xe131f7A95b62CbEeceB7b03F08790930e6894a7E",
            "tokens": [
                "wstETH"
            ],
            "baseRatePerYear": "0",
            "multiplierPerYear": "0.0461",
            "jumpMultiplierPerYear": "2.857",
            "kink": "0.65"
        },
        {
            "name": "JumpRate#Others",
            "contract": "JumpRateModelV2",
            "address": "0xE649Fd017356D314e79649fBE5E20A9EC827D286",
            "tokens": [
                "RETH",
                "pufETH",
                "rsETH",
                "weETH",
                "PT-weETH-26SEP2024",
                "PT-pufETH-26SEP2024",
                "PT-rsETH-26DEC2024",
                "PT-weETH-26DEC2024",
                "PT-pufETH-26DEC2024",
                "SolvBTC.BBN",
                "SolvBTC",
                "eBTC"
            ],
            "baseRatePerYear": "0",
            "multiplierPerYear": "0.15555",
            "jumpMultiplierPerYear": "5.582",
            "kink": "0.45"
        },
        {
            "name": "ZeroRate",
            "contract": "FixedInterestRateModel",
            "address": "0x901f52D04324879a37587406BEa16bcD1C11f061",
            "tokens": [
                "suUSD",
                "suETH",
                "suBTC"
            ],
            "initBorrowRate": "0",
            "initSupplyRate": "0"
        }
    ],
    "blocksPerYear": 31536000
};
//# sourceMappingURL=ethereum.js.map